import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal, Signal } from '@angular/core';
import { Sale } from 'app/interfaces/sale.interface';
import { SalesService } from 'app/services/sales.service';
import { SalesListItemComponent } from '../sales-list-item/sales-list-item.component';
import { UserInfo } from '../../../services/api.service'

@Component({
  selector: 'app-sales-list',
  standalone: true,
  templateUrl: './sales-list.component.html',
  styleUrl: './sales-list.component.scss',
  imports: [CommonModule, SalesListItemComponent]
})
export class SalesListComponent implements OnInit {

  @Input() sales: Signal<Sale[]> = signal<Sale[]>([]);
  @Input() userInfo: Signal<UserInfo>;
  @Output() onDelete: EventEmitter<void> = new EventEmitter<void>();

  constructor(private salesService: SalesService) {}

  public ngOnInit(): void {

  }
  public handleDelete(): void {
    this.onDelete.emit();
  }
}
